import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NavigationService } from '../store/navigation/navigation.service';

/**
 * Guard du root (`path: ''`). Résout la première page réellement accessible
 * pour l'utilisateur courant et y redirige via un UrlTree, plutôt que de
 * rediriger vers une route en dur non vérifiée.
 *
 * S'exécute après AuthenticationGuard, donc uniquement si authentifié.
 */
export const HomeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const navigationService = inject(NavigationService);

  return navigationService
    .resolveLandingUrl()
    .pipe(map((url) => router.parseUrl(url)));
};
